export default {
  productName: 'FightCamp Sound Sleeve',
  pathId: 'fightcamp-sound-sleeve',
  description: 'The FightCamp Sound Sleeve is the ultimate noise-reducing cover for your Free-Standing Bag—designed for early risers, apartment dwellers, and anyone who trains in shared spaces. Engineered with premium materials and tested for performance, it reduces impact noise by up to 80%, so you can unleash your power without disrupting your household.',
  shortDescription: 'The ultimate noise-reducing cover for your FightCamp Free-standing Bag.',
  testShopifyId: 'gid://shopify/Product/7721843785817',
  prodShopifyId: 'gid://shopify/Product/8531057705196',
  isSoldOut: false,
  primaryImg: {
    src: 'https://a.storyblok.com/f/152150/1200x825/aeda6884f2/fc_product_shoot_2025-107.jpg',
    alt: 'FightCamp Sound Sleeve',
  },
  lifestyleImage: {
    src: 'https://a.storyblok.com/f/152150/1648x1648/ea6b30a5cc/fc-freestanding-bag-ring.jpg',
    alt: 'FightCamp Sound Sleeve',
  },
  includesModalCopy: {},
  assets: [{
    src: 'https://a.storyblok.com/f/152150/1200x825/aeda6884f2/fc_product_shoot_2025-107.jpg',
    alt: 'FightCamp Sound Sleeve over free-standing bag',
  },
  {
    src: 'https://a.storyblok.com/f/152150/1200x825/75623c31af/fc_product_shoot_2025-110.jpg',
    alt: 'FightCamp Sound Sleeve zipper close up',
  },
  {
    src: 'https://a.storyblok.com/f/152150/1200x825/4ea02bb8ff/dscf0513-2.jpg',
    alt: 'FightCamp Sound Sleeve on free-standing bag, close up on base',
  },
  {
    src: 'https://a.storyblok.com/f/152150/1200x825/9e5914dba4/fc_product_shoot_2025-112.jpg',
    alt: 'FightCamp Sound Sleeve on free-standing bag, zipped up',
  },
  ],
  features: [
    {
      title: 'Features',
      copy: [
        '<strong>80% noise reduction</strong>: Scientifically tested to dampen impact sounds, transforming loud strikes into a low thud.',
        '<strong>Soft but strong</strong>: Dual-layer construction—13mm PU foam for shock absorption, wrapped in a high-density dobby weave outer shell.',
        '<strong>Train in comfort</strong>: Impact-absorbing foam cushions your knuckles without dulling your power.',
        '<strong>Zero-slip fit</strong>: Designed to zip tightly over your FightCamp Free-Standing Bag and stay put—even during high-volume combos.',
      ],
    },
    {
      title: 'Size & Fit',
      copy: [
        'Fits snugly over the FightCamp Free-Standing Bag.',
        'Secure fit with heavy-duty zipper and elastic edge grip.',
      ],
    },
    {
      title: 'Materials & Care',
      copy: [
        '<strong>Outer shell</strong>: 95% polyester / 5% spandex, dobby weave',
        '<strong>Fabric density</strong>: 280 GSM (grams per square meter)',
        '<strong>Foam layer</strong>: 13mm thick PU foam, density 18 kg/m³',
        '<strong>Color</strong>: White interior, black outer cover',
        '<strong>Fabric width</strong>: 160 cm',
        '<strong>Machine washable</strong> for easy upkeep',
      ],
    },
  ],
};
